<twc-trowser [ngClass]="{'hide-animation': isClosePopupSite}" [caption]="titlePopupSite | translate"
    class="dialog-project">
    <twc-trowser-content>
        <cw-create-job-site-content>
        </cw-create-job-site-content>
    </twc-trowser-content>
</twc-trowser>